<template>
	<div class="home-trend">
		<h2>Trend analysis</h2>
		<swiperMode :list="data" :space="15" :delay="2500"></swiperMode>
		<div class="period">
			<div :class="{ active: active == 1 }" @click="active = 1">1min</div>
			<div :class="{ active: active == 2 }" @click="active = 2">5min</div>
			<div :class="{ active: active == 3 }" @click="active = 3">15min</div>
			<div :class="{ active: active == 4 }" @click="active = 4">1day</div>
			<div :class="{ active: active == 5 }" @click="active = 5">1week</div>
			<div :class="{ active: active == 6 }" @click="active = 6">1mon</div>
		</div>
		<img :src="img" class="period-img">
	</div>
</template>
<script>
import swiperMode from './model5Swiper.vue';
export default {
	props: {
		data: {
			type: Array,
			default: () => [],
		},

		img: {
			type: String,
			default: require('@/assets/img-pc/92.ba552483.png'),
		},
	},
	components: {
		swiperMode
	},
	data() {
		return {
			active: 1, 
		};
	},
	methods: {

	},
};
</script>
<style lang="scss" scoped>
.home-trend {
	height: 560px;
	margin: 0 auto 120px;
	border-radius: 18px;
	background: #0d0e0f;
	padding: 30px 30px 0;

	.period-img {
		width: 100%;
		max-height: 330px;
	}

	.period {
		display: flex;
		margin-top: 40px;
		margin-bottom: 12px;

		>div {
			font-size: 16px;
			font-weight: 400;
			margin-right: 36px;
			cursor: pointer;

			&.active {
				color: #00a4d8;
			}
		}
	}

	h2 {
		font-size: 30px;
		line-height: 40px;
		margin-bottom: 30px;
	}
}
</style>